import React from "react";
import "./index.scss";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import withMotion from "../../../Utils/withMotion";

//Panels
// import PageNotFound from "../../../404";
import Hero from "./Hero";
import { SpeakWithDesigner } from "../../../CTA/CTA";
import Driveways from "./Pages/Driveways/Driveways";
import FireFeatures from "./Pages/FireFeatures/FireFeatures";
import GardenWalls from "./Pages/GardenBeds/GardenBeds";
import Patios from "./Pages/Patios/Patios";
import PoolDecks from "./Pages/PoolDecks/PoolDecks";
import Steps from "./Pages/Steps/Steps";
import Walkways from "./Pages/Walkways/Walkways";

const Categories = () => {
  return (
    <div className="container-fluid page-categories">
      <Hero />
      <Switch>
        <Route exact component={Driveways} path="/gallery/driveways" />
        <Route exact component={FireFeatures} path="/gallery/firefeatures" />
        <Route exact component={GardenWalls} path="/gallery/garden-walls" />
        <Route
          exact
          component={Patios}
          path="/gallery/patios"
        />
        <Route exact component={PoolDecks} path="/gallery/pool-decks" />
        <Route exact component={Steps} path="/gallery/steps-and-coping" />
        <Route exact component={Walkways} path="/gallery/walkways" />
        {/* <Route exact component={PageNotFound} path="*" /> */}
        <Redirect from="/gallery/*" to="/404" />
      </Switch>
      <SpeakWithDesigner />
    </div>
  );
};

export default withRouter(withMotion(Categories));
